import { render, staticRenderFns } from "./recommend-list.vue?vue&type=template&id=eb028d82&"
import script from "./recommend-list.vue?vue&type=script&lang=js&"
export * from "./recommend-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oohira/sites/giontsujiri/giontsujiri.co.jp_brand_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb028d82')) {
      api.createRecord('eb028d82', component.options)
    } else {
      api.reload('eb028d82', component.options)
    }
    module.hot.accept("./recommend-list.vue?vue&type=template&id=eb028d82&", function () {
      api.rerender('eb028d82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/store/menus/recommend-list.vue"
export default component.exports